import { EventStatus, NoShowCheckInsFilter } from '../services/network'

export type EventStatusFilter = EventStatus | 'InsufficientScans' | 'NoScans'

export const eventStatusFilters: EventStatusFilter[] = [
  EventStatus.Ok,
  EventStatus.LimitedAvailability,
  EventStatus.SoldOut,
  EventStatus.CancelledCreator,
  'InsufficientScans',
  'NoScans',
  EventStatus.CancelledNoShow,
  EventStatus.CancelledAdmin,
  EventStatus.Concluded
]

export function getEventStatusLabelKey(status: EventStatus, successfulCheckInsCount?: number | null): string {
  if (status !== EventStatus.CancelledNoShow) {
    return status
  }
  if (successfulCheckInsCount === 0) {
    return 'event_check_ins.none'
  }
  if (typeof successfulCheckInsCount === 'number' && successfulCheckInsCount > 0) {
    return 'event_check_ins.some'
  }
  return status
}

export function getEventStatusFilterLabelKey(filter: EventStatusFilter): string {
  switch (filter) {
    case 'InsufficientScans':
      return 'event_check_ins.some'
    case 'NoScans':
      return 'event_check_ins.none'
    case EventStatus.CancelledNoShow:
      return 'event_check_ins.unknown'
    default:
      return filter
  }
}

export function getEventSearchFilters(filters: EventStatusFilter[]): {
  status: EventStatus[] | undefined
  noShowCheckIns: NoShowCheckInsFilter[] | undefined
} {
  const status: EventStatus[] = []
  const noShowCheckIns: NoShowCheckInsFilter[] = []
  filters.forEach((filter) => {
    switch (filter) {
      case 'InsufficientScans':
        noShowCheckIns.push(NoShowCheckInsFilter.Some)
        break
      case 'NoScans':
        noShowCheckIns.push(NoShowCheckInsFilter.None)
        break
      case EventStatus.CancelledNoShow:
        noShowCheckIns.push(NoShowCheckInsFilter.Unknown)
        break
      default:
        status.push(filter)
    }
  })
  return {
    status: status.length > 0 ? status : undefined,
    noShowCheckIns: noShowCheckIns.length > 0 ? noShowCheckIns : undefined
  }
}
